//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../no/TaggedObject.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
let d=[[[1,"Curve",0,"ScCollector",0],[1,"Point1",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"Point2",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"RemoveLimitPoints",1,0],[0,"Reverse",1,0]],[[["object_array_count","object_array"],"GetPathObjects",{},0,0],[["object_array"],"SetPathObjects",{},1,0],[["path"],"SetPath",{},1,0],[["curve"],"SetLimitsFromCurve",{},1,0],[[],"GetPath",{R_:{pathCurve:"Curve"}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Die.DieLimitsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.DieLimitsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;